import React from "react";

function SocialHeaders() {
  return (
    <div className="socialHeadersContainer">
      <h1>Social Media Links</h1>
      <h3>Feel Free To Contact Us</h3>
    </div>
  );
}

export default SocialHeaders;
